import { useState } from 'react';
import Modal from '../../components/Modal/Modal';
import { ModalContext } from './ModalContext';

export const ModalProvider = ({ children }: { children: React.ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState<React.ReactNode>();
  const onClose = () => {
    setIsOpen(false);
    setContent(undefined);
  };
  const onOpen = (content: React.ReactNode) => {
    setIsOpen(true);
    setContent(content);
  };
  return (
    <ModalContext.Provider
      value={{
        isOpen,
        content,
        onClose,
        onOpen,
      }}
    >
      <Modal />
      {children}
    </ModalContext.Provider>
  );
};
